import { useCallback, useEffect } from 'react'

// Mouse events
export const MOUSE_UP = 'mouseup'

export function useOutsideClick(handleClose: Function, ref: React.MutableRefObject<any>) {
  const handleClick = useCallback(
    (event: MouseEvent) => {
      if (ref?.current?.contains && !ref.current.contains(event.target)) {
        handleClose()
      }
    },
    [handleClose, ref]
  )

  useEffect(() => {
    document.addEventListener(MOUSE_UP, handleClick)
    return () => {
      document.removeEventListener(MOUSE_UP, handleClick)
    }
  }, [handleClick])
}
